import { CARD_HEIGHT, CARD_WIDTH, APP_WIDTH, RESOLUTION } from '../utils/commonUtils';
import CardContainer from './cardContainer';
import GameFieldContainer from './gameFieldContainer';
import HandContainer from './handContainer';
import HandContainerV2 from './handContainerV2';
import MainDeckContainer from './mainDeckContainer';
import CharacterAreaContainer from './characterAreaContainer';
import DonsContainer from './donsContainer';
import LeaderContainer from './leaderContainer';
import StageContainer from './stageContainer';
import TrashContainer from './trashContainer';

const LEADER_POSITION = {
    x: -13*RESOLUTION,
    y: -233*RESOLUTION,
};

const DONS_POSITION = {
    x: -480*RESOLUTION,
    y: -305*RESOLUTION,
};

const CHARACTER_AREA_POSITION = {
    x: 0,
    y: -684*RESOLUTION,
};

const STAGE_POSITION = {
    x: 292*RESOLUTION,
    y: -367*RESOLUTION,
};

const TRASH_POSITION = {
    x: 292*RESOLUTION,
    y: -260*RESOLUTION,
};

const playerLeaderContainerLabel = 'playerLeaderContainer';
const playerHandContainerLabel = 'playerHandContainer';
const playerMainDeckContainerLabel = 'playerMainDeckContainer';
const playerCharacterAreaContainerLabel = 'playerCharacterAreaContainer';
const playerDonsContainerLabel = 'playerDonsContainer';
const playerStageContainerLabel = 'playerStageContainer';
const playerTrashContainerLabel = 'playerTrashContainer';

export default class PlayerContainer extends GameFieldContainer {
    constructor(playerState, onCardTapped, onCardReleased, onCardHeld) {
        super('player', onCardTapped, onCardReleased, onCardHeld)
        this.createLeaderCard(playerState);
        this.createMainDeckContainer(playerState);
        this.createCharacterAreaContainer();
        this.createDonsContainer(playerState);
        this.createStageContainer();
        this.createTrashContainer();
        this.createHandContainer(playerState);
    }

    createLeaderCard(playerState) {
        const playerLeaderContainer = new LeaderContainer(playerState);
        playerLeaderContainer.label = playerLeaderContainerLabel;
        playerLeaderContainer.x = LEADER_POSITION.x;
        playerLeaderContainer.y = LEADER_POSITION.y;
        this.addChild(playerLeaderContainer);
    }

    createHandContainer(playerState) {
        const playerHandContainer = new HandContainer(playerState.handCount, playerState.hand);
        playerHandContainer.label = playerHandContainerLabel;
        playerHandContainer.x = 0;
        playerHandContainer.y = 0;
        this.addChild(playerHandContainer);
    }

    createMainDeckContainer(playerState) {
        const playerMainDeckContainer = new MainDeckContainer(playerState.deckCount);
        playerMainDeckContainer.label = playerMainDeckContainerLabel;
        playerMainDeckContainer.x = (APP_WIDTH / 2) - APP_WIDTH * 0.08;
        playerMainDeckContainer.y = -CARD_HEIGHT + CARD_HEIGHT * 0.06;
        this.addChild(playerMainDeckContainer);
    }
    
    createCharacterAreaContainer() {
        const playerCharacterAreaContainer = new CharacterAreaContainer();
        playerCharacterAreaContainer.label = playerCharacterAreaContainerLabel;
        playerCharacterAreaContainer.x = CHARACTER_AREA_POSITION.x;
        playerCharacterAreaContainer.y = CHARACTER_AREA_POSITION.y;
        this.addChild(playerCharacterAreaContainer);
    }

    createDonsContainer(playerState) {
        const playerDonsContainer = new DonsContainer(playerState);
        playerDonsContainer.label = playerDonsContainerLabel;
        playerDonsContainer.x = DONS_POSITION.x;
        playerDonsContainer.y = DONS_POSITION.y;
        this.addChild(playerDonsContainer);
    }

    createStageContainer() {
        const playerStageContainer = new StageContainer();
        playerStageContainer.label = playerStageContainerLabel;
        playerStageContainer.x = STAGE_POSITION.x;
        playerStageContainer.y = STAGE_POSITION.y;
        this.addChild(playerStageContainer);
    }

    createTrashContainer() {
        const playerTrashContainer = new TrashContainer(true);
        playerTrashContainer.label = playerTrashContainerLabel;
        playerTrashContainer.x = TRASH_POSITION.x;
        playerTrashContainer.y = TRASH_POSITION.y;
        this.addChild(playerTrashContainer);
    }

    updateLeader(playerState, clientGameState) {
        this.getChildByLabel(playerLeaderContainerLabel).update(playerState, clientGameState);
    }

    updateHand(gameState, playerState, clientGameState) {
        this.getChildByLabel(playerHandContainerLabel).updateHand(gameState, playerState, clientGameState);
    }

    updateMainDeck(deckCount) {
        this.getChildByLabel(playerMainDeckContainerLabel).updateText(deckCount.toString());
    }

    updateCharacterArea(characterArea, clientGameState) {
        this.getChildByLabel(playerCharacterAreaContainerLabel).updateCharacterArea(characterArea, clientGameState);
    }

    updateDonsContainer(playerState, clientGameState) {
        this.getChildByLabel(playerDonsContainerLabel).update(playerState, clientGameState);
    }

    updateStageContainer(playerState, clientGameState) {
        this.getChildByLabel(playerStageContainerLabel).update(playerState, clientGameState);
    }

    updateTrashContainer(playerState) {
        this.getChildByLabel(playerTrashContainerLabel).update(playerState);
    }
}
